import useMeetingReportUiStore from "@app/analytics/MeetingReport/stores/ui";
import { EditIcon } from "@app/common/assets/icons";
import useResponsiveView from "@app/common/hooks/useResponsiveView";

import MenuItem from "@rui/MenuItem";

const RenameReport = ({ disabled }: { disabled: boolean }) => {
  const setDialog = useMeetingReportUiStore((state) => state.setDialog);
  const { inMobileView } = useResponsiveView();

  const focusReportTitle = () => {
    const element = document.getElementById("meeting-report-title");
    element?.click();
  };

  const handleClickRenameReport = () => {
    if (inMobileView) {
      setDialog("rename_report");
    } else {
      focusReportTitle();
    }
  };

  return (
    <MenuItem
      disabled={disabled}
      icon={<EditIcon />}
      onClick={handleClickRenameReport}
    >
      Rename Report
    </MenuItem>
  );
};

export default RenameReport;
